<div class="modal-inner">
    <div class="modal-inner-inner w-100">
        <h1>Verlof opmerking</h1>
        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Opmerking</mat-label>
            <input [formControl]="form.controls.comment" matInput type="text" placeholder="Opmerking" />
        </mat-form-field>
        @if (data.currentHourType === RealisationHourtype.sleep) {
            <div>
                <b>Project</b>
                <input class="search" [formControl]="fcProjectSearch" placeholder="Zoeken in projecten" />
                <div class="results">
                    @if (searching) {
                        <div class="result text-center">aan het zoeken...</div>
                    }
                    @for (project of projects; track project.afas_project_id) {
                        <div class="result" (click)="setProject(project)">
                            <strong>{{ project.afas_project_id }}</strong> {{ project.name }}
                        </div>
                    }
                </div>
            </div>
        }
    </div>
    <div class="buttons">
        <button
            class="planning-button confirm"
            [disabled]="form.invalid"
            [mat-dialog-close]="form.value"
            mat-raised-button
            color="primary">
            Toevoegen
        </button>
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
</div>
